import api from './api';

export const fetchAbandonReviewReasonsService = () =>
  api('/api/v1/abandon_review_reasons/');
